// components/StepIndicator.tsx
import React from 'react';

interface StepIndicatorProps {
  currentStep: number;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep }) => (
  <div className="mb-8">
    <div className="flex items-center justify-between mb-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
          إنشاء مهمة جديدة
        </h1>
        <p className="text-gray-500 mt-1">
          {currentStep === 7 ? 'اكتمل!' : `الخطوة ${Math.floor(currentStep)} من 6`}
        </p>
      </div>
      <div className="text-left">
        <div className="text-sm text-gray-500">التقدم</div>
        <div className="text-2xl font-bold text-blue-600">
          {currentStep === 7 ? '100' : Math.round((Math.floor(currentStep) / 6) * 100)}%
        </div>
      </div>
    </div>
    <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
      <div 
        className="h-full bg-gradient-to-r from-blue-500 to-blue-600 rounded-full transition-all duration-500 ease-out"
        style={{ width: `${currentStep === 7 ? 100 : (Math.floor(currentStep) / 6) * 100}%` }}
      />
    </div>
  </div>
);